// Высота приложения по видимой части экрана, а не по layout-viewport.
//
// Зачем: на iOS в standalone-режиме открытие экранной клавиатуры НЕ сжимает
// layout-viewport. Вёрстка на `height: 100%` продолжает считать, что экран
// прежней высоты, и строка ввода вместе с кнопкой отправки уезжает под
// клавиатуру — ровно там, где на телефоне идёт вся работа.
//
// visualViewport знает настоящую видимую высоту и сообщает о её изменениях.
// Кладём её в CSS-переменную `--app-h`, на которую опирается `.ab-app`.

import { useEffect } from 'react'

export function useViewportHeight(): void {
  useEffect(() => {
    const viewport = window.visualViewport

    const apply = () => {
      const height = viewport?.height ?? window.innerHeight
      document.documentElement.style.setProperty('--app-h', `${Math.round(height)}px`)

      // Открывая клавиатуру, iOS дополнительно проматывает страницу вверх.
      // Приложение занимает ровно экран и прокручиваться не должно — возвращаем.
      if (window.scrollY !== 0 || (viewport?.offsetTop ?? 0) !== 0) {
        window.scrollTo(0, 0)
      }
    }

    apply()

    if (viewport) {
      viewport.addEventListener('resize', apply)
      viewport.addEventListener('scroll', apply)
    }
    window.addEventListener('orientationchange', apply)
    window.addEventListener('resize', apply)

    return () => {
      if (viewport) {
        viewport.removeEventListener('resize', apply)
        viewport.removeEventListener('scroll', apply)
      }
      window.removeEventListener('orientationchange', apply)
      window.removeEventListener('resize', apply)
    }
  }, [])
}
